import "./src/shared/styles/global.css";
import { CommonLayout } from "./src/layout";
import { WrapPageElementBrowserArgs } from "gatsby";
import { LoadingManager } from "./src/providers/loading-manager";

window.LoadingManager = LoadingManager;

window.onload = () => {
  console.debug("WINDOW ONLOAD!");
};

export const onInitialClientRender = () => {
  console.debug("CLIENT INITIAL RENDER!");
};

export const wrapPageElement = ({
  element,
  props,
}: WrapPageElementBrowserArgs) => {
  return <CommonLayout props={props}>{element}</CommonLayout>;
};
